<template>
	<div class="bg-white rounded-lg shadow-card p-4 w-56 z-10 centered">
		<p class="text-center opacity-75">
			<slot>I am popup!</slot>
		</p>
	</div>
</template>

<script>
	export default {
        name: "Popup",
	}
</script>

<style scoped>
	.centered {
		margin-left: -7rem;
	}
</style>
